import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { componentMapper, ComponentMapperKeys } from "../../../constant";

const columns = [
  { maxWidth: "270px", value: "Phase" },
  { maxWidth: "130px", value: "Day range" },
  { maxWidth: "100%", value: "Key activities" },
];

const RowWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      padding="16px 16px 16px 0"
      borderBottom="1px solid #0000001F"
      width="100%"
    >
      {children}
    </Stack>
  );
};
export const DayRangeTable = ({
  rows,
}: {
  rows: {
    type: ComponentMapperKeys;
    value: never;
  }[][];
}) => {
  if (!rows || !Array.isArray(rows)) return null;

  return (
    <Stack width="100%">
      <RowWrapper>
        <Stack flexDirection="row" alignItems="center" flexGrow={1}>
          {columns.map(({ maxWidth, value }) => (
            <Typography
              key={value}
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: 500,
                color: "#1F2932",
                maxWidth,
                width: "100%",
              }}
            >
              {value}
            </Typography>
          ))}
        </Stack>
      </RowWrapper>
      {rows.map((row, index) => (
        <RowWrapper key={index}>
          {row.map(({ type, value }, i) => (
            <Stack
              maxWidth={columns[i].maxWidth}
              width="100%"
              alignSelf="flex-start"
            >
              {componentMapper[type](value as any)}
            </Stack>
          ))}
        </RowWrapper>
      ))}
    </Stack>
  );
};
